<template>
  <div>
    <FormComponent @created="refreshList" :prefillData="prefillData" />
    <ListComponent :reload="reloadList" @copy-coupon="onCopyCoupon" />
  </div>
</template>

<script>
import FormComponent from "@/components/CouponCode/coupon-code-form.vue";
import ListComponent from "@/components/CouponCode/coupon-code-list.vue";

export default {
  components: { FormComponent, ListComponent },

  data() {
    return {
      reloadList: false,
      prefillData: null,
    };
  },

  methods: {
    refreshList() {
      this.reloadList = !this.reloadList;
    },
    onCopyCoupon(item) {
      this.prefillData = { ...item };
    }
  }
};
</script>
